import { useMutation } from "@tanstack/react-query";
import {
  postBookingCheckout,
  postBookingInquiry,
  postCalendlyStart,
} from "../api/bookings";
import { useContent } from "./useContent";
import { serviceItem } from "../analytics/catalog";
import { track } from "../analytics/track";

export function useBookingInquiryMutation() {
  return useMutation({
    mutationFn: postBookingInquiry,
    onSuccess: (_data, payload) => {
      track({ name: "lead", source: `inquiry:${payload.serviceKey}` });
    },
  });
}

export function useBookingCheckoutMutation() {
  const { data: content } = useContent();
  return useMutation({
    mutationFn: postBookingCheckout,
    onMutate: (payload) => {
      const item = serviceItem(content, payload.serviceKey);
      if (item) track({ name: "initiate_checkout", ...item });
    },
  });
}

export function useCalendlyStartMutation() {
  const { data: content } = useContent();
  return useMutation({
    mutationFn: postCalendlyStart,
    onMutate: (payload) => {
      const item = serviceItem(content, payload.serviceKey);
      if (item) track({ name: "initiate_checkout", ...item });
    },
  });
}
